module.exports = __webpack_public_path__ + "assets/img/limit_128.472b3304.png";